import { API } from '../common/api';
import { BASE_URL, FIELD_URL } from '../common/env';
import { DownloadFormat } from '../../pages/map/types/Shapefiles';
import AgoToast from '../../components/Toast/AgoToast';

const getProducerList = async (isAuditor: boolean) => {
  return API.get(`${BASE_URL}/base/growers/producers`, { verificationGroup: isAuditor ? 'Verification 1' : undefined }).then((res) => {
    return res.data;
  });
};

const getProducerById = async (growerId: string) => {
  return API.get(`${BASE_URL}/base/growers/leads/${growerId}`).then((res) => {
    return res.data;
  });
};

const getJourneyById = async (journeyId: string) => {
  return API.get(`${BASE_URL}/base/producer/journey/${journeyId}`).then((res) => {
    return res.data;
  });
};

const createJourney = async (leadId?: string, opportunityId?: string) => {
  return API.post(`${BASE_URL}/base/producer`, { leadId, opportunityId }).then((res) => {
    return {
      ...res.data,
      id: res.data.journeyId,
    };
  });
};

const checkBoundariesStatus = async (producers: { [key: string]: string | null }, type: DownloadFormat, generate: boolean, key?: string) => {
  return API.downloadBulkFiles(`${FIELD_URL}/field-service/fields/boundaries-status/${generate}?type=${type}`, producers, {
    key,
  }).then((res) => {
    return res.data;
  });
};

const downloadProducerBoundaries = async (producers: { [key: string]: string | null }, type: DownloadFormat) => {
  const res = await checkBoundariesStatus(producers, type, true);
  let status = res.status;
  const key = res.key;

  const showErrorToast = () => {
    AgoToast.showToast({
      title: 'Request failed',
      message: 'Failed to download boundaries',
      type: 'error',
      toastId: 'producer-boundaries-download-error-toast',
    });
  };

  AgoToast.showToast({
    title: 'Request sent',
    message: `Generating boundaries for desired producers. This may take a few minutes.`,
    type: 'info',
    toastId: `producer-boundaries-pending`,
  });

  while (status === 'pending') {
    await new Promise((resolve) => setTimeout(resolve, 5000));

    const check = await checkBoundariesStatus(producers, type, false, key);
    status = check.status;
  }

  if (status === 'error') {
    showErrorToast();
    return;
  }

  return API.get(`${FIELD_URL}/field-service/fields/boundaries/producers?key=${key}`)
    .then((res) => {
      const link = document.createElement('a');
      link.href = res.data;
      link.setAttribute('download', '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(async () => {
      showErrorToast();
    });
};

export const ProducerService = {
  getProducerList,
  getProducerById,
  getJourneyById,
  createJourney,
  downloadProducerBoundaries,
};
